// extracted by mini-css-extract-plugin
export default {"whats-next-tab-text":"WhatsNextTab_whats-next-tab-text__p-oW8"};